// i18nOwl-ignore [boolean, date, number, string]
import type {UserPropertyADto} from '@cohort/admin-schemas/userProperty';
import {Badge} from '@cohort/merchants/components/Badge';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface Props {
  userProperty: UserPropertyADto;
}
export const UserPropertyDataTypeBadge: React.FC<Props> = ({userProperty}): JSX.Element => {
  const {t} = useTranslation('components', {
    keyPrefix: 'userPropertyDataTypeBadge',
  });

  return (
    <Badge
      text={t(userProperty.dataType)}
      backgroundColor="bg-slate-100"
      textColor="text-slate-600"
    />
  );
};
